import { ArrowBack, ArrowForward } from '@mui/icons-material/';
import {
  Apps,
  WorkOutline,
  DeviceHub,
  Business,
  AccountTree,
  Extension,
  PeopleAlt,
  Computer,
  School,
} from '@mui/icons-material/';
import { GeneralContext } from 'Redux/context';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material/';
import { LogoKappaWhite, LogoKappaWhiteRounded } from 'Images/index';
import { useContext, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import useTranslation from 'Hooks/useTranslation';
import style from './style';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import rolesApi from 'Api/axios/roles-api';
import { usePermissionStore } from 'stores/permissions-store';

const { DrawerHeader, Drawer, useStyles } = style;

export default function MiniDrawer() {
  const history = useHistory();
  const { t2 } = useTranslation('SideBar');
  const { roleId } = useSelector(userSelector);
  // const { open, setOpen, rolePermissions } = useContext(GeneralContext);
  const classes = useStyles();

  const rawPermissions = usePermissionStore(state => state.permissions);
  const setPermissions = usePermissionStore(state => state.setPermissions);

  // Consulta el listado de los permisos para determinar si el usuario tiene
  // acceso a las diferentes opciones del menú lateral.
  useEffect(() => {
    if (!roleId) return;
    rolesApi.readPermissions(roleId).then(response => {
      if (response.data) {
        // Guardamos permisos crudos; este componente hace el mapeo a menú
        setPermissions(response.data.permissions);
      }
    });
  }, [roleId]);

  // Items base
  const baseStart = useMemo(() => ({ icon: <Apps />, route: '/dashboard', text: t2('Dashboard') }), [t2]);
  const baseEnd = useMemo(() => ({ icon: <Computer />, route: '/mis-cursos', text: t2('MyCourses') }), [t2]);

  // Mapa de permisos -> item de menú
  const permissionMap = useMemo(
    () => ({
      job_title: { icon: <WorkOutline />, route: '/puestos', text: t2('JobTitle') },
      department: { icon: <DeviceHub />, route: '/departamentos', text: t2('Departments') },
      enterprise: { icon: <Business />, route: '/empresa', text: t2('Company') },
      course_definition: { icon: <AccountTree />, route: '/definicion', text: t2('DefinitionCourses') },
      report: { icon: <Extension />, route: '/reporte/empleados', text: t2('reports') },
      employee_development: { icon: <School />, route: '/empleado/me', text: t2('Profile') },
      employee: { icon: <PeopleAlt />, route: '/empleados', text: t2('Employees') },
      course: { icon: <Computer />, route: '/cursos', text: t2('Courses') },
    }),
    [t2]
  );

  const order = [
    'job_title',
    'department',
    'enterprise',
    'course_definition',
    'report',
    'employee',
    'course',
    'employee_development',
  ];

  const menuItems = useMemo(() => {
    if (!rawPermissions?.length) return [baseStart, baseEnd];
    const assigned = new Set(
      rawPermissions
        .filter(p => p?.assigned)
        .map(p => (typeof p.key === 'string' ? p.key.split('.')[0] : ''))
        .filter(Boolean)
    );
    const out = [baseStart];
    order.forEach(k => {
      if (assigned.has(k) && permissionMap[k]) out.push(permissionMap[k]);
    });
    out.push(baseEnd);
    return out;
  }, [rawPermissions, baseStart, baseEnd, permissionMap]);

  const isRouteSelected = route => {
    const currentPath = history.location.pathname;

    if (route === '/reporte/empleados') {
      return currentPath.startsWith('/reporte/empleados') || currentPath.startsWith('/reporte/cursos');
    }

    return currentPath === route || currentPath.startsWith(`${route}/`);
  };

  return (
    <Drawer variant="permanent" open={open} classes={{ paper: classes.MuiDrawer }}>
      <DrawerHeader>
        <img
          src={open ? LogoKappaWhite : LogoKappaWhiteRounded}
          className={open ? classes.imageStyleOpen : classes.imageStyleClosed}
          alt="icono"
        />
      </DrawerHeader>

      <List>
        {menuItems.map((object, index) => {
          const isSelected = isRouteSelected(object.route);
          return (
            <ListItemButton
              key={index}
              className={isSelected ? classes.selectedItem : classes.listItem}
              onClick={() => history.push(object.route)}
            >
              <ListItemIcon>{object.icon}</ListItemIcon>
              <ListItemText primary={object.text} key={1} />
            </ListItemButton>
          );
        })}
        <ListItemButton key={20} className={classes.sideBarArrow} onClick={() => {}}>
          <ListItemIcon>{open ? <ArrowBack /> : <ArrowForward />}</ListItemIcon>
          <ListItemText primary={t2('HideMenu')} />
        </ListItemButton>
      </List>
    </Drawer>
  );
}
